// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-dialog-title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    padding: 16px 24px 0;
    margin-bottom: 20px;
    border-bottom: none;
}

.action-dialog-content {
    padding: 16px 24px;
}

/* Step Indicator */
.step-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    gap: 0;
}

.step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.step-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #e0e0e0;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    transition: background-color 0.2s;
}

.step-active .step-circle {
    background-color: #1565c0;
    color: #fff;
}

.step-completed .step-circle {
    background-color: #1565c0;
    color: #fff;
}

.step-check-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    line-height: 16px;
}

.step-label {
    font-size: 11px;
    color: #666;
    white-space: nowrap;
}

.step-active .step-label {
    color: #1565c0;
    font-weight: 600;
}

.step-completed .step-label {
    color: #1565c0;
}

.step-connector {
    flex: 1;
    height: 2px;
    background-color: #e0e0e0;
    margin: 0 6px;
    margin-bottom: 16px;
    min-width: 40px;
    transition: background-color 0.2s;
}

.step-connector.completed {
    background-color: #1565c0;
}

/* Step description */
.step-description {
    font-size: 13px;
    color: #555;
    margin-bottom: 14px;
}

/* Action options list */
.action-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.action-option {
    display: flex;
    align-items: center;
    gap: 12px;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    padding: 12px 14px;
    cursor: pointer;
    transition: border-color 0.15s, background-color 0.15s;
    background-color: #fff;
}

.action-option:hover {
    border-color: #1565c0;
    background-color: #f0f4ff;
}

.action-option.selected {
    border-color: #1565c0;
    background-color: #e8f0fe;
}

.action-option-check {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
}

.option-check-icon {
    color: #1565c0;
    font-size: 22px;
    width: 22px;
    height: 22px;
}

.option-icon {
    color: #888;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.action-option.selected .option-icon {
    color: #1565c0;
}

.action-option-text {
    flex: 1;
}

.action-option-title {
    font-size: 14px;
    font-weight: 600;
    color: #222;
}

.action-option-desc {
    font-size: 12px;
    color: #666;
    margin-top: 2px;
}

/* Form fields */
.form-group {
    margin-bottom: 16px;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    font-size: 13px;
    color: #495057;
}

.form-control {
    display: block;
    width: 100%;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 4px;
    box-sizing: border-box;
    transition: border-color 0.15s;
}

.form-control:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

select.form-control {
    cursor: pointer;
}

textarea.form-control {
    resize: vertical;
    min-height: 70px;
}

/* Autocomplete */
.autocomplete-wrapper {
    position: relative;
}

.autocomplete-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 9999;
    background: #fff;
    border: 1px solid #ced4da;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 180px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.autocomplete-option {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 13px;
}

.autocomplete-option:hover {
    background-color: #f0f4ff;
}

.autocomplete-empty {
    padding: 8px 12px;
    font-size: 13px;
    color: #888;
    list-style: none;
}

/* Consent */
.consent-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Confirm summary */
.confirm-summary {
    background-color: #f5f5f5;
    border-radius: 6px;
    padding: 16px;
}

.confirm-title {
    font-size: 15px;
    font-weight: 600;
    color: #1565c0;
    margin-bottom: 6px;
}

.confirm-detail {
    font-size: 13px;
    color: #444;
}

/* Alert */
.alert {
    border-radius: 4px;
    padding: 10px 14px;
    margin-bottom: 14px;
}

.alert-danger {
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
}

.alert ul {
    padding-left: 18px;
    margin-bottom: 0;
}

/* Footer */
.action-dialog-footer {
    display: flex;
    justify-content: space-between !important;
    padding: 8px 24px;
    gap: 8px;
}

.footer-spacer {
    flex: 1;
}

.btn-back-action {
    margin-left: 8px;
}

.btn-back-action::after {
    content: '' !important;
    display: none !important;
}

.btn-cancel-action::after {
    content: '' !important;
    display: none !important;
}

.ai-recommendation {
    margin-top: 12px;
    font-size: 13px;
    color: #1565c0;
    font-style: italic;
}

/* AMORE assign type radio group */
.amore-assign-radio-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 16px;
}

.amore-assign-radio-group input[type="radio"] {
    margin: 0;
    cursor: pointer;
}

.amore-assign-radio-group label {
    display: inline;
    margin-bottom: 0;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/action-dialog/action-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sDAAsD;IACtD,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,yCAAyC;IACzC,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".action-dialog-title {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 600;\n    padding: 16px 24px 0;\n    margin-bottom: 20px;\n    border-bottom: none;\n}\n\n.action-dialog-content {\n    padding: 16px 24px;\n}\n\n/* Step Indicator */\n.step-indicator {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    gap: 0;\n}\n\n.step-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.step-circle {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background-color: #e0e0e0;\n    color: #666;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 600;\n    transition: background-color 0.2s;\n}\n\n.step-active .step-circle {\n    background-color: #1565c0;\n    color: #fff;\n}\n\n.step-completed .step-circle {\n    background-color: #1565c0;\n    color: #fff;\n}\n\n.step-check-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n}\n\n.step-label {\n    font-size: 11px;\n    color: #666;\n    white-space: nowrap;\n}\n\n.step-active .step-label {\n    color: #1565c0;\n    font-weight: 600;\n}\n\n.step-completed .step-label {\n    color: #1565c0;\n}\n\n.step-connector {\n    flex: 1;\n    height: 2px;\n    background-color: #e0e0e0;\n    margin: 0 6px;\n    margin-bottom: 16px;\n    min-width: 40px;\n    transition: background-color 0.2s;\n}\n\n.step-connector.completed {\n    background-color: #1565c0;\n}\n\n/* Step description */\n.step-description {\n    font-size: 13px;\n    color: #555;\n    margin-bottom: 14px;\n}\n\n/* Action options list */\n.action-options {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.action-option {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    border: 1px solid #d0d0d0;\n    border-radius: 6px;\n    padding: 12px 14px;\n    cursor: pointer;\n    transition: border-color 0.15s, background-color 0.15s;\n    background-color: #fff;\n}\n\n.action-option:hover {\n    border-color: #1565c0;\n    background-color: #f0f4ff;\n}\n\n.action-option.selected {\n    border-color: #1565c0;\n    background-color: #e8f0fe;\n}\n\n.action-option-check {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n}\n\n.option-check-icon {\n    color: #1565c0;\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n}\n\n.option-icon {\n    color: #888;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.action-option.selected .option-icon {\n    color: #1565c0;\n}\n\n.action-option-text {\n    flex: 1;\n}\n\n.action-option-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #222;\n}\n\n.action-option-desc {\n    font-size: 12px;\n    color: #666;\n    margin-top: 2px;\n}\n\n/* Form fields */\n.form-group {\n    margin-bottom: 16px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 6px;\n    font-weight: 500;\n    font-size: 13px;\n    color: #495057;\n}\n\n.form-control {\n    display: block;\n    width: 100%;\n    padding: 8px 12px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    box-sizing: border-box;\n    transition: border-color 0.15s;\n}\n\n.form-control:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\nselect.form-control {\n    cursor: pointer;\n}\n\ntextarea.form-control {\n    resize: vertical;\n    min-height: 70px;\n}\n\n/* Autocomplete */\n.autocomplete-wrapper {\n    position: relative;\n}\n\n.autocomplete-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 9999;\n    background: #fff;\n    border: 1px solid #ced4da;\n    border-top: none;\n    border-radius: 0 0 4px 4px;\n    max-height: 180px;\n    overflow-y: auto;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);\n}\n\n.autocomplete-option {\n    padding: 8px 12px;\n    cursor: pointer;\n    font-size: 13px;\n}\n\n.autocomplete-option:hover {\n    background-color: #f0f4ff;\n}\n\n.autocomplete-empty {\n    padding: 8px 12px;\n    font-size: 13px;\n    color: #888;\n    list-style: none;\n}\n\n/* Consent */\n.consent-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* Confirm summary */\n.confirm-summary {\n    background-color: #f5f5f5;\n    border-radius: 6px;\n    padding: 16px;\n}\n\n.confirm-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1565c0;\n    margin-bottom: 6px;\n}\n\n.confirm-detail {\n    font-size: 13px;\n    color: #444;\n}\n\n/* Alert */\n.alert {\n    border-radius: 4px;\n    padding: 10px 14px;\n    margin-bottom: 14px;\n}\n\n.alert-danger {\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    color: #721c24;\n}\n\n.alert ul {\n    padding-left: 18px;\n    margin-bottom: 0;\n}\n\n/* Footer */\n.action-dialog-footer {\n    display: flex;\n    justify-content: space-between !important;\n    padding: 8px 24px;\n    gap: 8px;\n}\n\n.footer-spacer {\n    flex: 1;\n}\n\n.btn-back-action {\n    margin-left: 8px;\n}\n\n.btn-back-action::after {\n    content: '' !important;\n    display: none !important;\n}\n\n.btn-cancel-action::after {\n    content: '' !important;\n    display: none !important;\n}\n\n.ai-recommendation {\n    margin-top: 12px;\n    font-size: 13px;\n    color: #1565c0;\n    font-style: italic;\n}\n\n/* AMORE assign type radio group */\n.amore-assign-radio-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px 16px;\n}\n\n.amore-assign-radio-group input[type=\"radio\"] {\n    margin: 0;\n    cursor: pointer;\n}\n\n.amore-assign-radio-group label {\n    display: inline;\n    margin-bottom: 0;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
